import { createSvgIcon } from '@mui/material/utils';

export const RadioBoxUncheckedIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none">
    <circle
      cx="12"
      cy="12"
      r="8"
      fill="white"
      stroke="#40444D"
      strokeWidth="2"
    />
  </svg>,
  'RadioBoxUnchecked',
);
